import { prismicClient } from '@/data/prismicClient';
import { ArcadeHowToPlayDocument } from '@/types/prismic.generated';
import { useQuery } from '@tanstack/react-query';

export const useArcadeGameHowToPlayContent = (uid: string) => {
    return useQuery({
        queryKey: ['arcade-game-how-to-play-content', uid],
        queryFn: () => {
            if (!uid) {
                return undefined;
            }

            return prismicClient.getByUID<ArcadeHowToPlayDocument>('arcade_how_to_play', uid);
        },
        enabled: !!uid,
    });
};
